import cn from 'classnames';
import { createPortal } from 'react-dom';
import { useEffect } from 'react';
import Svg from 'UI/components/Svg';
import styles from './styles.module.scss';

export const Modal = ({
  open,
  children,
  onClose,
  className,
}) => {
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (open && typeof window !== 'undefined') {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = '15px';

      window.addEventListener('keydown', handleEscape);

      return () => {
        document.body.style.overflow = 'auto';
        document.body.style.paddingRight = '0';

        window.removeEventListener('keydown', handleEscape);
      };
    }
  }, [
    open,
    onClose,
  ]);

  if (typeof window === 'undefined') {
    return null;
  }

  return createPortal(
    <div
      className={cn(styles.backdrop, { [styles.open]: open })}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={cn(styles.modal, { [styles.open]: open }, className)}
      >
        <button
          type="button"
          onClick={onClose}
          className={styles['close-button']}
        >
          <Svg
            type="xClose"
            className={styles.icon}
          />
        </button>
        {children}
      </div>
    </div>,
    document.body,
  );
};
